import { render, staticRenderFns } from "./BaseCardInspection.vue?vue&type=template&id=7e7e13cf&scoped=true&"
import script from "./BaseCardInspection.vue?vue&type=script&lang=ts&"
export * from "./BaseCardInspection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardInspection.vue?vue&type=style&index=0&id=7e7e13cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7e13cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
